/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as DocumentViewerImport } from './routes/document-viewer'
import { Route as LayoutPrivateImport } from './routes/_layout-private'
import { Route as IndexImport } from './routes/index'
import { Route as LayoutPrivateOperationIndexImport } from './routes/_layout-private/operation/index'
import { Route as LayoutPrivateNewsIndexImport } from './routes/_layout-private/news/index'
import { Route as LayoutPrivateLawIndexImport } from './routes/_layout-private/law/index'
import { Route as LayoutPrivateFinanceIndexImport } from './routes/_layout-private/finance/index'
import { Route as LayoutPrivateDashboardIndexImport } from './routes/_layout-private/dashboard/index'
import { Route as LayoutPrivateNewsMutateImport } from './routes/_layout-private/news/mutate'
import { Route as LayoutPrivateNewsIdImport } from './routes/_layout-private/news/$id'
import { Route as LayoutPrivateLawMutateImport } from './routes/_layout-private/law/mutate'
import { Route as LayoutPrivateLawIdImport } from './routes/_layout-private/law/$id'
import { Route as LayoutPrivateChatLayoutImport } from './routes/_layout-private/chat/_layout'
import { Route as LayoutPrivateReportTaxObligationsIndexImport } from './routes/_layout-private/report/tax-obligations/index'
import { Route as LayoutPrivateReportOverviewIndexImport } from './routes/_layout-private/report/overview/index'
import { Route as LayoutPrivateReportObligationIndexImport } from './routes/_layout-private/report/obligation/index'
import { Route as LayoutPrivateReportNonFinancialAssessmentIndexImport } from './routes/_layout-private/report/non-financial-assessment/index'
import { Route as LayoutPrivateReportFinanceIndexImport } from './routes/_layout-private/report/finance/index'
import { Route as LayoutPrivateReportDirectorIndexImport } from './routes/_layout-private/report/director/index'
import { Route as LayoutPrivateReportBoardOfDirectorsIndexImport } from './routes/_layout-private/report/board-of-directors/index'
import { Route as LayoutPrivateReportActionPlanIndexImport } from './routes/_layout-private/report/action-plan/index'
import { Route as LayoutPrivateChatLayoutIndexImport } from './routes/_layout-private/chat/_layout/index'
import { Route as LayoutPrivateAccountManagementSubAccountIndexImport } from './routes/_layout-private/account-management/sub-account/index'
import { Route as LayoutPrivateAccountManagementSoeIndexImport } from './routes/_layout-private/account-management/soe/index'
import { Route as LayoutPrivateReportActionPlanPreviewImport } from './routes/_layout-private/report/action-plan/preview'
import { Route as LayoutPrivateReportActionPlanEditImport } from './routes/_layout-private/report/action-plan/edit'
import { Route as LayoutPrivateReportActionPlanAddnewImport } from './routes/_layout-private/report/action-plan/addnew'
import { Route as LayoutPrivateReportActionPlanIdImport } from './routes/_layout-private/report/action-plan/$id'
import { Route as LayoutPrivateAccountManagementSoeInformationImport } from './routes/_layout-private/account-management/soe/_information'
import { Route as LayoutPrivateReportTaxObligationsTaxLiabilityPlanIndexImport } from './routes/_layout-private/report/tax-obligations/tax-liability-plan/index'
import { Route as LayoutPrivateReportTaxObligationsDividendPlanIndexImport } from './routes/_layout-private/report/tax-obligations/dividend-plan/index'
import { Route as LayoutPrivateReportObligationDividendIndexImport } from './routes/_layout-private/report/obligation/dividend/index'
import { Route as LayoutPrivateReportObligationAssignTaxObligationIndexImport } from './routes/_layout-private/report/obligation/assign-tax-obligation/index'
import { Route as LayoutPrivateReportNonFinancialAssessmentAnswerIndexImport } from './routes/_layout-private/report/non-financial-assessment/answer/index'
import { Route as LayoutPrivateReportDirectorDetailsIndexImport } from './routes/_layout-private/report/director/details/index'
import { Route as LayoutPrivateReportBoardOfDirectorsDetailsIndexImport } from './routes/_layout-private/report/board-of-directors/details/index'
import { Route as LayoutPrivateChatLayoutIdIndexImport } from './routes/_layout-private/chat/_layout/$id/index'
import { Route as LayoutPrivateReportTaxObligationsTaxLiabilityPlanEditImport } from './routes/_layout-private/report/tax-obligations/tax-liability-plan/edit'
import { Route as LayoutPrivateReportTaxObligationsTaxLiabilityPlanAddNewImport } from './routes/_layout-private/report/tax-obligations/tax-liability-plan/add-new'
import { Route as LayoutPrivateReportTaxObligationsDividendPlanEditImport } from './routes/_layout-private/report/tax-obligations/dividend-plan/edit'
import { Route as LayoutPrivateReportTaxObligationsDividendPlanAddNewImport } from './routes/_layout-private/report/tax-obligations/dividend-plan/add-new'
import { Route as LayoutPrivateReportObligationAssignTaxObligationEditImport } from './routes/_layout-private/report/obligation/assign-tax-obligation/edit'
import { Route as LayoutPrivateReportObligationAssignTaxObligationAddNewImport } from './routes/_layout-private/report/obligation/assign-tax-obligation/add-new'
import { Route as LayoutPrivateReportObligationAssignTaxObligationIdImport } from './routes/_layout-private/report/obligation/assign-tax-obligation/$id'
import { Route as LayoutPrivateReportFinanceCompanyLayoutImport } from './routes/_layout-private/report/finance/company/_layout'
import { Route as LayoutPrivateReportFinanceBankLayoutImport } from './routes/_layout-private/report/finance/bank/_layout'
import { Route as LayoutPrivateReportFinanceIdLayoutImport } from './routes/_layout-private/report/finance/$id/_layout'
import { Route as LayoutPrivateChatLayoutPrivateCreateImport } from './routes/_layout-private/chat/_layout/private/create'
import { Route as LayoutPrivateChatLayoutGroupMutateImport } from './routes/_layout-private/chat/_layout/group/mutate'
import { Route as LayoutPrivateReportDirectorDetailsAnswerIndexImport } from './routes/_layout-private/report/director/details/answer/index'
import { Route as LayoutPrivateReportBoardOfDirectorsDetailsAnswerIndexImport } from './routes/_layout-private/report/board-of-directors/details/answer/index'
import { Route as LayoutPrivateChatLayoutGroupIdIndexImport } from './routes/_layout-private/chat/_layout/group/$id/index'
import { Route as LayoutPrivateChatLayoutIdDocumentIndexImport } from './routes/_layout-private/chat/_layout/$id/document/index'
import { Route as LayoutPrivateAccountManagementSoeInformationSecretariatIndexImport } from './routes/_layout-private/account-management/soe/_information/secretariat/index'
import { Route as LayoutPrivateAccountManagementSoeInformationLandIndexImport } from './routes/_layout-private/account-management/soe/_information/land/index'
import { Route as LayoutPrivateAccountManagementSoeInformationJointVentureIndexImport } from './routes/_layout-private/account-management/soe/_information/joint-venture/index'
import { Route as LayoutPrivateAccountManagementSoeInformationGeneralIndexImport } from './routes/_layout-private/account-management/soe/_information/general/index'
import { Route as LayoutPrivateAccountManagementSoeInformationDirectorIndexImport } from './routes/_layout-private/account-management/soe/_information/director/index'
import { Route as LayoutPrivateAccountManagementSoeInformationDepartmentIndexImport } from './routes/_layout-private/account-management/soe/_information/department/index'
import { Route as LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIndexImport } from './routes/_layout-private/account-management/soe/_information/board-of-directors/index'
import { Route as LayoutPrivateAccountManagementSoeInformationAccountIndexImport } from './routes/_layout-private/account-management/soe/_information/account/index'
import { Route as LayoutPrivateChatLayoutGroupIdInfoImport } from './routes/_layout-private/chat/_layout/group/$id/info'
import { Route as LayoutPrivateChatLayoutGroupIdDocumentImport } from './routes/_layout-private/chat/_layout/group/$id/document'
import { Route as LayoutPrivateAccountManagementSoeInformationLandMutateImport } from './routes/_layout-private/account-management/soe/_information/land/mutate'
import { Route as LayoutPrivateAccountManagementSoeInformationLandDetailIdImport } from './routes/_layout-private/account-management/soe/_information/land/$detailId'
import { Route as LayoutPrivateAccountManagementSoeInformationJointVentureMutateImport } from './routes/_layout-private/account-management/soe/_information/joint-venture/mutate'
import { Route as LayoutPrivateAccountManagementSoeInformationJointVentureIdImport } from './routes/_layout-private/account-management/soe/_information/joint-venture/$id'
import { Route as LayoutPrivateAccountManagementSoeInformationGeneralIdImport } from './routes/_layout-private/account-management/soe/_information/general/$id'
import { Route as LayoutPrivateAccountManagementSoeInformationDirectorPreviewImport } from './routes/_layout-private/account-management/soe/_information/director/preview'
import { Route as LayoutPrivateAccountManagementSoeInformationDirectorMutateImport } from './routes/_layout-private/account-management/soe/_information/director/mutate'
import { Route as LayoutPrivateAccountManagementSoeInformationDirectorIdImport } from './routes/_layout-private/account-management/soe/_information/director/$id'
import { Route as LayoutPrivateAccountManagementSoeInformationDepartmentMutateImport } from './routes/_layout-private/account-management/soe/_information/department/mutate'
import { Route as LayoutPrivateAccountManagementSoeInformationDepartmentIdImport } from './routes/_layout-private/account-management/soe/_information/department/$id'
import { Route as LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsPreviewImport } from './routes/_layout-private/account-management/soe/_information/board-of-directors/preview'
import { Route as LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsMutateImport } from './routes/_layout-private/account-management/soe/_information/board-of-directors/mutate'
import { Route as LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIdImport } from './routes/_layout-private/account-management/soe/_information/board-of-directors/$id'
import { Route as LayoutPrivateReportFinanceCompanyLayoutResultIndexImport } from './routes/_layout-private/report/finance/company/_layout/result/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutOwnerEquityIndexImport } from './routes/_layout-private/report/finance/company/_layout/owner-equity/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutIndicatorsIndexImport } from './routes/_layout-private/report/finance/company/_layout/indicators/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFixAssetsIndexImport } from './routes/_layout-private/report/finance/company/_layout/fix-assets/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFinancePropertyIndexImport } from './routes/_layout-private/report/finance/company/_layout/finance-property/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFinanceDebtIndexImport } from './routes/_layout-private/report/finance/company/_layout/finance-debt/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodIndexImport } from './routes/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodIndexImport } from './routes/_layout-private/report/finance/company/_layout/cash-flow-direct-method/index'
import { Route as LayoutPrivateReportFinanceBankLayoutResultIndexImport } from './routes/_layout-private/report/finance/bank/_layout/result/index'
import { Route as LayoutPrivateReportFinanceBankLayoutOwnerEquityIndexImport } from './routes/_layout-private/report/finance/bank/_layout/owner-equity/index'
import { Route as LayoutPrivateReportFinanceBankLayoutFinancePropertyIndexImport } from './routes/_layout-private/report/finance/bank/_layout/finance-property/index'
import { Route as LayoutPrivateReportFinanceBankLayoutFinanceDebtIndexImport } from './routes/_layout-private/report/finance/bank/_layout/finance-debt/index'
import { Route as LayoutPrivateReportFinanceBankLayoutCashFlowIndexImport } from './routes/_layout-private/report/finance/bank/_layout/cash-flow/index'
import { Route as LayoutPrivateReportFinanceIdLayoutResultIndexImport } from './routes/_layout-private/report/finance/$id/_layout/result/index'
import { Route as LayoutPrivateReportFinanceIdLayoutOwnerEquityIndexImport } from './routes/_layout-private/report/finance/$id/_layout/owner-equity/index'
import { Route as LayoutPrivateReportFinanceIdLayoutFinancePropertyIndexImport } from './routes/_layout-private/report/finance/$id/_layout/finance-property/index'
import { Route as LayoutPrivateReportFinanceIdLayoutFinanceDebtIndexImport } from './routes/_layout-private/report/finance/$id/_layout/finance-debt/index'
import { Route as LayoutPrivateReportFinanceIdLayoutCashFlowIndirectMethodIndexImport } from './routes/_layout-private/report/finance/$id/_layout/cash-flow-indirect-method/index'
import { Route as LayoutPrivateReportFinanceIdLayoutCashFlowDirectMethodIndexImport } from './routes/_layout-private/report/finance/$id/_layout/cash-flow-direct-method/index'
import { Route as LayoutPrivateAccountManagementSoeInformationLandAddIndexImport } from './routes/_layout-private/account-management/soe/_information/land/add/index'
import { Route as LayoutPrivateAccountManagementSoeInformationJointVentureAddNewIndexImport } from './routes/_layout-private/account-management/soe/_information/joint-venture/add-new/index'
import { Route as LayoutPrivateAccountManagementSoeInformationGeneralEditIndexImport } from './routes/_layout-private/account-management/soe/_information/general/edit/index'
import { Route as LayoutPrivateAccountManagementSoeInformationDirectorAddNewIndexImport } from './routes/_layout-private/account-management/soe/_information/director/add-new/index'
import { Route as LayoutPrivateAccountManagementSoeInformationDepartmentAddIndexImport } from './routes/_layout-private/account-management/soe/_information/department/add/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutResultEditImport } from './routes/_layout-private/report/finance/company/_layout/result/edit'
import { Route as LayoutPrivateReportFinanceCompanyLayoutOwnerEquityEditImport } from './routes/_layout-private/report/finance/company/_layout/owner-equity/edit'
import { Route as LayoutPrivateReportFinanceCompanyLayoutIndicatorsEditImport } from './routes/_layout-private/report/finance/company/_layout/indicators/edit'
import { Route as LayoutPrivateReportFinanceCompanyLayoutIndicatorsAddImport } from './routes/_layout-private/report/finance/company/_layout/indicators/add'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFixAssetsEditImport } from './routes/_layout-private/report/finance/company/_layout/fix-assets/edit'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFixAssetsAddImport } from './routes/_layout-private/report/finance/company/_layout/fix-assets/add'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFinancePropertyEditImport } from './routes/_layout-private/report/finance/company/_layout/finance-property/edit'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFinanceDebtEditImport } from './routes/_layout-private/report/finance/company/_layout/finance-debt/edit'
import { Route as LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodEditImport } from './routes/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/edit'
import { Route as LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodEditImport } from './routes/_layout-private/report/finance/company/_layout/cash-flow-direct-method/edit'
import { Route as LayoutPrivateReportFinanceBankLayoutResultEditImport } from './routes/_layout-private/report/finance/bank/_layout/result/edit'
import { Route as LayoutPrivateReportFinanceBankLayoutOwnerEquityEditImport } from './routes/_layout-private/report/finance/bank/_layout/owner-equity/edit'
import { Route as LayoutPrivateReportFinanceBankLayoutFinancePropertyEditImport } from './routes/_layout-private/report/finance/bank/_layout/finance-property/edit'
import { Route as LayoutPrivateReportFinanceBankLayoutFinanceDebtEditImport } from './routes/_layout-private/report/finance/bank/_layout/finance-debt/edit'
import { Route as LayoutPrivateReportFinanceBankLayoutCashFlowEditImport } from './routes/_layout-private/report/finance/bank/_layout/cash-flow/edit'
import { Route as LayoutPrivateReportFinanceCompanyLayoutResultAddIndexImport } from './routes/_layout-private/report/finance/company/_layout/result/add/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutOwnerEquityAddIndexImport } from './routes/_layout-private/report/finance/company/_layout/owner-equity/add/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFinancePropertyAddIndexImport } from './routes/_layout-private/report/finance/company/_layout/finance-property/add/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutFinanceDebtAddIndexImport } from './routes/_layout-private/report/finance/company/_layout/finance-debt/add/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodAddIndexImport } from './routes/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/add/index'
import { Route as LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodAddIndexImport } from './routes/_layout-private/report/finance/company/_layout/cash-flow-direct-method/add/index'

// Create Virtual Routes

const LayoutPrivateChatImport = createFileRoute('/_layout-private/chat')()
const LayoutPrivateAccountManagementSoeImport = createFileRoute(
  '/_layout-private/account-management/soe',
)()
const LayoutPrivateReportFinanceCompanyImport = createFileRoute(
  '/_layout-private/report/finance/company',
)()
const LayoutPrivateReportFinanceBankImport = createFileRoute(
  '/_layout-private/report/finance/bank',
)()
const LayoutPrivateReportFinanceIdImport = createFileRoute(
  '/_layout-private/report/finance/$id',
)()

// Create/Update Routes

const DocumentViewerRoute = DocumentViewerImport.update({
  path: '/document-viewer',
  getParentRoute: () => rootRoute,
} as any)

const LayoutPrivateRoute = LayoutPrivateImport.update({
  id: '/_layout-private',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LayoutPrivateChatRoute = LayoutPrivateChatImport.update({
  path: '/chat',
  getParentRoute: () => LayoutPrivateRoute,
} as any)

const LayoutPrivateAccountManagementSoeRoute =
  LayoutPrivateAccountManagementSoeImport.update({
    path: '/account-management/soe',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateOperationIndexRoute =
  LayoutPrivateOperationIndexImport.update({
    path: '/operation/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateNewsIndexRoute = LayoutPrivateNewsIndexImport.update({
  path: '/news/',
  getParentRoute: () => LayoutPrivateRoute,
} as any)

const LayoutPrivateLawIndexRoute = LayoutPrivateLawIndexImport.update({
  path: '/law/',
  getParentRoute: () => LayoutPrivateRoute,
} as any)

const LayoutPrivateFinanceIndexRoute = LayoutPrivateFinanceIndexImport.update({
  path: '/finance/',
  getParentRoute: () => LayoutPrivateRoute,
} as any)

const LayoutPrivateDashboardIndexRoute =
  LayoutPrivateDashboardIndexImport.update({
    path: '/dashboard/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateNewsMutateRoute = LayoutPrivateNewsMutateImport.update({
  path: '/news/mutate',
  getParentRoute: () => LayoutPrivateRoute,
} as any)

const LayoutPrivateNewsIdRoute = LayoutPrivateNewsIdImport.update({
  path: '/news/$id',
  getParentRoute: () => LayoutPrivateRoute,
} as any)

const LayoutPrivateLawMutateRoute = LayoutPrivateLawMutateImport.update({
  path: '/law/mutate',
  getParentRoute: () => LayoutPrivateRoute,
} as any)

const LayoutPrivateLawIdRoute = LayoutPrivateLawIdImport.update({
  path: '/law/$id',
  getParentRoute: () => LayoutPrivateRoute,
} as any)

const LayoutPrivateChatLayoutRoute = LayoutPrivateChatLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => LayoutPrivateChatRoute,
} as any)

const LayoutPrivateReportFinanceCompanyRoute =
  LayoutPrivateReportFinanceCompanyImport.update({
    path: '/report/finance/company',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportFinanceBankRoute =
  LayoutPrivateReportFinanceBankImport.update({
    path: '/report/finance/bank',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportFinanceIdRoute =
  LayoutPrivateReportFinanceIdImport.update({
    path: '/report/finance/$id',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportTaxObligationsIndexRoute =
  LayoutPrivateReportTaxObligationsIndexImport.update({
    path: '/report/tax-obligations/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportOverviewIndexRoute =
  LayoutPrivateReportOverviewIndexImport.update({
    path: '/report/overview/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportObligationIndexRoute =
  LayoutPrivateReportObligationIndexImport.update({
    path: '/report/obligation/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportNonFinancialAssessmentIndexRoute =
  LayoutPrivateReportNonFinancialAssessmentIndexImport.update({
    path: '/report/non-financial-assessment/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportFinanceIndexRoute =
  LayoutPrivateReportFinanceIndexImport.update({
    path: '/report/finance/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportDirectorIndexRoute =
  LayoutPrivateReportDirectorIndexImport.update({
    path: '/report/director/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportBoardOfDirectorsIndexRoute =
  LayoutPrivateReportBoardOfDirectorsIndexImport.update({
    path: '/report/board-of-directors/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportActionPlanIndexRoute =
  LayoutPrivateReportActionPlanIndexImport.update({
    path: '/report/action-plan/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateChatLayoutIndexRoute =
  LayoutPrivateChatLayoutIndexImport.update({
    path: '/',
    getParentRoute: () => LayoutPrivateChatLayoutRoute,
  } as any)

const LayoutPrivateAccountManagementSubAccountIndexRoute =
  LayoutPrivateAccountManagementSubAccountIndexImport.update({
    path: '/account-management/sub-account/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateAccountManagementSoeIndexRoute =
  LayoutPrivateAccountManagementSoeIndexImport.update({
    path: '/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeRoute,
  } as any)

const LayoutPrivateReportActionPlanPreviewRoute =
  LayoutPrivateReportActionPlanPreviewImport.update({
    path: '/report/action-plan/preview',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportActionPlanEditRoute =
  LayoutPrivateReportActionPlanEditImport.update({
    path: '/report/action-plan/edit',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportActionPlanAddnewRoute =
  LayoutPrivateReportActionPlanAddnewImport.update({
    path: '/report/action-plan/addnew',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportActionPlanIdRoute =
  LayoutPrivateReportActionPlanIdImport.update({
    path: '/report/action-plan/$id',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationRoute =
  LayoutPrivateAccountManagementSoeInformationImport.update({
    id: '/_information',
    getParentRoute: () => LayoutPrivateAccountManagementSoeRoute,
  } as any)

const LayoutPrivateReportTaxObligationsTaxLiabilityPlanIndexRoute =
  LayoutPrivateReportTaxObligationsTaxLiabilityPlanIndexImport.update({
    path: '/report/tax-obligations/tax-liability-plan/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportTaxObligationsDividendPlanIndexRoute =
  LayoutPrivateReportTaxObligationsDividendPlanIndexImport.update({
    path: '/report/tax-obligations/dividend-plan/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportObligationDividendIndexRoute =
  LayoutPrivateReportObligationDividendIndexImport.update({
    path: '/report/obligation/dividend/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportObligationAssignTaxObligationIndexRoute =
  LayoutPrivateReportObligationAssignTaxObligationIndexImport.update({
    path: '/report/obligation/assign-tax-obligation/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportNonFinancialAssessmentAnswerIndexRoute =
  LayoutPrivateReportNonFinancialAssessmentAnswerIndexImport.update({
    path: '/report/non-financial-assessment/answer/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportDirectorDetailsIndexRoute =
  LayoutPrivateReportDirectorDetailsIndexImport.update({
    path: '/report/director/details/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportBoardOfDirectorsDetailsIndexRoute =
  LayoutPrivateReportBoardOfDirectorsDetailsIndexImport.update({
    path: '/report/board-of-directors/details/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateChatLayoutIdIndexRoute =
  LayoutPrivateChatLayoutIdIndexImport.update({
    path: '/$id/',
    getParentRoute: () => LayoutPrivateChatLayoutRoute,
  } as any)

const LayoutPrivateReportTaxObligationsTaxLiabilityPlanEditRoute =
  LayoutPrivateReportTaxObligationsTaxLiabilityPlanEditImport.update({
    path: '/report/tax-obligations/tax-liability-plan/edit',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportTaxObligationsTaxLiabilityPlanAddNewRoute =
  LayoutPrivateReportTaxObligationsTaxLiabilityPlanAddNewImport.update({
    path: '/report/tax-obligations/tax-liability-plan/add-new',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportTaxObligationsDividendPlanEditRoute =
  LayoutPrivateReportTaxObligationsDividendPlanEditImport.update({
    path: '/report/tax-obligations/dividend-plan/edit',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportTaxObligationsDividendPlanAddNewRoute =
  LayoutPrivateReportTaxObligationsDividendPlanAddNewImport.update({
    path: '/report/tax-obligations/dividend-plan/add-new',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportObligationAssignTaxObligationEditRoute =
  LayoutPrivateReportObligationAssignTaxObligationEditImport.update({
    path: '/report/obligation/assign-tax-obligation/edit',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportObligationAssignTaxObligationAddNewRoute =
  LayoutPrivateReportObligationAssignTaxObligationAddNewImport.update({
    path: '/report/obligation/assign-tax-obligation/add-new',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportObligationAssignTaxObligationIdRoute =
  LayoutPrivateReportObligationAssignTaxObligationIdImport.update({
    path: '/report/obligation/assign-tax-obligation/$id',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutRoute =
  LayoutPrivateReportFinanceCompanyLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutRoute =
  LayoutPrivateReportFinanceBankLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => LayoutPrivateReportFinanceBankRoute,
  } as any)

const LayoutPrivateReportFinanceIdLayoutRoute =
  LayoutPrivateReportFinanceIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => LayoutPrivateReportFinanceIdRoute,
  } as any)

const LayoutPrivateChatLayoutPrivateCreateRoute =
  LayoutPrivateChatLayoutPrivateCreateImport.update({
    path: '/private/create',
    getParentRoute: () => LayoutPrivateChatLayoutRoute,
  } as any)

const LayoutPrivateChatLayoutGroupMutateRoute =
  LayoutPrivateChatLayoutGroupMutateImport.update({
    path: '/group/mutate',
    getParentRoute: () => LayoutPrivateChatLayoutRoute,
  } as any)

const LayoutPrivateReportDirectorDetailsAnswerIndexRoute =
  LayoutPrivateReportDirectorDetailsAnswerIndexImport.update({
    path: '/report/director/details/answer/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateReportBoardOfDirectorsDetailsAnswerIndexRoute =
  LayoutPrivateReportBoardOfDirectorsDetailsAnswerIndexImport.update({
    path: '/report/board-of-directors/details/answer/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)

const LayoutPrivateChatLayoutGroupIdIndexRoute =
  LayoutPrivateChatLayoutGroupIdIndexImport.update({
    path: '/group/$id/',
    getParentRoute: () => LayoutPrivateChatLayoutRoute,
  } as any)

const LayoutPrivateChatLayoutIdDocumentIndexRoute =
  LayoutPrivateChatLayoutIdDocumentIndexImport.update({
    path: '/$id/document/',
    getParentRoute: () => LayoutPrivateChatLayoutRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationSecretariatIndexRoute =
  LayoutPrivateAccountManagementSoeInformationSecretariatIndexImport.update({
    path: '/secretariat/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationLandIndexRoute =
  LayoutPrivateAccountManagementSoeInformationLandIndexImport.update({
    path: '/land/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationJointVentureIndexRoute =
  LayoutPrivateAccountManagementSoeInformationJointVentureIndexImport.update({
    path: '/joint-venture/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationGeneralIndexRoute =
  LayoutPrivateAccountManagementSoeInformationGeneralIndexImport.update({
    path: '/general/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDirectorIndexRoute =
  LayoutPrivateAccountManagementSoeInformationDirectorIndexImport.update({
    path: '/director/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDepartmentIndexRoute =
  LayoutPrivateAccountManagementSoeInformationDepartmentIndexImport.update({
    path: '/department/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIndexRoute =
  LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIndexImport.update(
    {
      path: '/board-of-directors/',
      getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
    } as any,
  )

const LayoutPrivateAccountManagementSoeInformationAccountIndexRoute =
  LayoutPrivateAccountManagementSoeInformationAccountIndexImport.update({
    path: '/account/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateChatLayoutGroupIdInfoRoute =
  LayoutPrivateChatLayoutGroupIdInfoImport.update({
    path: '/group/$id/info',
    getParentRoute: () => LayoutPrivateChatLayoutRoute,
  } as any)

const LayoutPrivateChatLayoutGroupIdDocumentRoute =
  LayoutPrivateChatLayoutGroupIdDocumentImport.update({
    path: '/group/$id/document',
    getParentRoute: () => LayoutPrivateChatLayoutRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationLandMutateRoute =
  LayoutPrivateAccountManagementSoeInformationLandMutateImport.update({
    path: '/land/mutate',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationLandDetailIdRoute =
  LayoutPrivateAccountManagementSoeInformationLandDetailIdImport.update({
    path: '/land/$detailId',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationJointVentureMutateRoute =
  LayoutPrivateAccountManagementSoeInformationJointVentureMutateImport.update({
    path: '/joint-venture/mutate',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationJointVentureIdRoute =
  LayoutPrivateAccountManagementSoeInformationJointVentureIdImport.update({
    path: '/joint-venture/$id',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationGeneralIdRoute =
  LayoutPrivateAccountManagementSoeInformationGeneralIdImport.update({
    path: '/general/$id',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDirectorPreviewRoute =
  LayoutPrivateAccountManagementSoeInformationDirectorPreviewImport.update({
    path: '/director/preview',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDirectorMutateRoute =
  LayoutPrivateAccountManagementSoeInformationDirectorMutateImport.update({
    path: '/director/mutate',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDirectorIdRoute =
  LayoutPrivateAccountManagementSoeInformationDirectorIdImport.update({
    path: '/director/$id',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDepartmentMutateRoute =
  LayoutPrivateAccountManagementSoeInformationDepartmentMutateImport.update({
    path: '/department/mutate',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDepartmentIdRoute =
  LayoutPrivateAccountManagementSoeInformationDepartmentIdImport.update({
    path: '/department/$id',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsPreviewRoute =
  LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsPreviewImport.update(
    {
      path: '/board-of-directors/preview',
      getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
    } as any,
  )

const LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsMutateRoute =
  LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsMutateImport.update(
    {
      path: '/board-of-directors/mutate',
      getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
    } as any,
  )

const LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIdRoute =
  LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIdImport.update({
    path: '/board-of-directors/$id',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutResultIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutResultIndexImport.update({
    path: '/result/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutOwnerEquityIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutOwnerEquityIndexImport.update({
    path: '/owner-equity/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutIndicatorsIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutIndicatorsIndexImport.update({
    path: '/indicators/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFixAssetsIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutFixAssetsIndexImport.update({
    path: '/fix-assets/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFinancePropertyIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutFinancePropertyIndexImport.update({
    path: '/finance-property/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFinanceDebtIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutFinanceDebtIndexImport.update({
    path: '/finance-debt/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodIndexImport.update(
    {
      path: '/cash-flow-indirect-method/',
      getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
    } as any,
  )

const LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodIndexImport.update(
    {
      path: '/cash-flow-direct-method/',
      getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
    } as any,
  )

const LayoutPrivateReportFinanceBankLayoutResultIndexRoute =
  LayoutPrivateReportFinanceBankLayoutResultIndexImport.update({
    path: '/result/',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutOwnerEquityIndexRoute =
  LayoutPrivateReportFinanceBankLayoutOwnerEquityIndexImport.update({
    path: '/owner-equity/',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutFinancePropertyIndexRoute =
  LayoutPrivateReportFinanceBankLayoutFinancePropertyIndexImport.update({
    path: '/finance-property/',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutFinanceDebtIndexRoute =
  LayoutPrivateReportFinanceBankLayoutFinanceDebtIndexImport.update({
    path: '/finance-debt/',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutCashFlowIndexRoute =
  LayoutPrivateReportFinanceBankLayoutCashFlowIndexImport.update({
    path: '/cash-flow/',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceIdLayoutResultIndexRoute =
  LayoutPrivateReportFinanceIdLayoutResultIndexImport.update({
    path: '/result/',
    getParentRoute: () => LayoutPrivateReportFinanceIdLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceIdLayoutOwnerEquityIndexRoute =
  LayoutPrivateReportFinanceIdLayoutOwnerEquityIndexImport.update({
    path: '/owner-equity/',
    getParentRoute: () => LayoutPrivateReportFinanceIdLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceIdLayoutFinancePropertyIndexRoute =
  LayoutPrivateReportFinanceIdLayoutFinancePropertyIndexImport.update({
    path: '/finance-property/',
    getParentRoute: () => LayoutPrivateReportFinanceIdLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceIdLayoutFinanceDebtIndexRoute =
  LayoutPrivateReportFinanceIdLayoutFinanceDebtIndexImport.update({
    path: '/finance-debt/',
    getParentRoute: () => LayoutPrivateReportFinanceIdLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceIdLayoutCashFlowIndirectMethodIndexRoute =
  LayoutPrivateReportFinanceIdLayoutCashFlowIndirectMethodIndexImport.update({
    path: '/cash-flow-indirect-method/',
    getParentRoute: () => LayoutPrivateReportFinanceIdLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceIdLayoutCashFlowDirectMethodIndexRoute =
  LayoutPrivateReportFinanceIdLayoutCashFlowDirectMethodIndexImport.update({
    path: '/cash-flow-direct-method/',
    getParentRoute: () => LayoutPrivateReportFinanceIdLayoutRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationLandAddIndexRoute =
  LayoutPrivateAccountManagementSoeInformationLandAddIndexImport.update({
    path: '/land/add/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationJointVentureAddNewIndexRoute =
  LayoutPrivateAccountManagementSoeInformationJointVentureAddNewIndexImport.update(
    {
      path: '/joint-venture/add-new/',
      getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
    } as any,
  )

const LayoutPrivateAccountManagementSoeInformationGeneralEditIndexRoute =
  LayoutPrivateAccountManagementSoeInformationGeneralEditIndexImport.update({
    path: '/general/edit/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDirectorAddNewIndexRoute =
  LayoutPrivateAccountManagementSoeInformationDirectorAddNewIndexImport.update({
    path: '/director/add-new/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateAccountManagementSoeInformationDepartmentAddIndexRoute =
  LayoutPrivateAccountManagementSoeInformationDepartmentAddIndexImport.update({
    path: '/department/add/',
    getParentRoute: () => LayoutPrivateAccountManagementSoeInformationRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutResultEditRoute =
  LayoutPrivateReportFinanceCompanyLayoutResultEditImport.update({
    path: '/result/edit',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutOwnerEquityEditRoute =
  LayoutPrivateReportFinanceCompanyLayoutOwnerEquityEditImport.update({
    path: '/owner-equity/edit',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutIndicatorsEditRoute =
  LayoutPrivateReportFinanceCompanyLayoutIndicatorsEditImport.update({
    path: '/indicators/edit',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutIndicatorsAddRoute =
  LayoutPrivateReportFinanceCompanyLayoutIndicatorsAddImport.update({
    path: '/indicators/add',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFixAssetsEditRoute =
  LayoutPrivateReportFinanceCompanyLayoutFixAssetsEditImport.update({
    path: '/fix-assets/edit',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFixAssetsAddRoute =
  LayoutPrivateReportFinanceCompanyLayoutFixAssetsAddImport.update({
    path: '/fix-assets/add',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFinancePropertyEditRoute =
  LayoutPrivateReportFinanceCompanyLayoutFinancePropertyEditImport.update({
    path: '/finance-property/edit',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFinanceDebtEditRoute =
  LayoutPrivateReportFinanceCompanyLayoutFinanceDebtEditImport.update({
    path: '/finance-debt/edit',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodEditRoute =
  LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodEditImport.update(
    {
      path: '/cash-flow-indirect-method/edit',
      getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
    } as any,
  )

const LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodEditRoute =
  LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodEditImport.update({
    path: '/cash-flow-direct-method/edit',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutResultEditRoute =
  LayoutPrivateReportFinanceBankLayoutResultEditImport.update({
    path: '/result/edit',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutOwnerEquityEditRoute =
  LayoutPrivateReportFinanceBankLayoutOwnerEquityEditImport.update({
    path: '/owner-equity/edit',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutFinancePropertyEditRoute =
  LayoutPrivateReportFinanceBankLayoutFinancePropertyEditImport.update({
    path: '/finance-property/edit',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutFinanceDebtEditRoute =
  LayoutPrivateReportFinanceBankLayoutFinanceDebtEditImport.update({
    path: '/finance-debt/edit',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceBankLayoutCashFlowEditRoute =
  LayoutPrivateReportFinanceBankLayoutCashFlowEditImport.update({
    path: '/cash-flow/edit',
    getParentRoute: () => LayoutPrivateReportFinanceBankLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutResultAddIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutResultAddIndexImport.update({
    path: '/result/add/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutOwnerEquityAddIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutOwnerEquityAddIndexImport.update({
    path: '/owner-equity/add/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFinancePropertyAddIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutFinancePropertyAddIndexImport.update({
    path: '/finance-property/add/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutFinanceDebtAddIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutFinanceDebtAddIndexImport.update({
    path: '/finance-debt/add/',
    getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
  } as any)

const LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodAddIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodAddIndexImport.update(
    {
      path: '/cash-flow-indirect-method/add/',
      getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
    } as any,
  )

const LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodAddIndexRoute =
  LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodAddIndexImport.update(
    {
      path: '/cash-flow-direct-method/add/',
      getParentRoute: () => LayoutPrivateReportFinanceCompanyLayoutRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout-private': {
      id: '/_layout-private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutPrivateImport
      parentRoute: typeof rootRoute
    }
    '/document-viewer': {
      id: '/document-viewer'
      path: '/document-viewer'
      fullPath: '/document-viewer'
      preLoaderRoute: typeof DocumentViewerImport
      parentRoute: typeof rootRoute
    }
    '/_layout-private/chat': {
      id: '/_layout-private/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof LayoutPrivateChatImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/chat/_layout': {
      id: '/_layout-private/chat/_layout'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof LayoutPrivateChatLayoutImport
      parentRoute: typeof LayoutPrivateChatRoute
    }
    '/_layout-private/law/$id': {
      id: '/_layout-private/law/$id'
      path: '/law/$id'
      fullPath: '/law/$id'
      preLoaderRoute: typeof LayoutPrivateLawIdImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/law/mutate': {
      id: '/_layout-private/law/mutate'
      path: '/law/mutate'
      fullPath: '/law/mutate'
      preLoaderRoute: typeof LayoutPrivateLawMutateImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/news/$id': {
      id: '/_layout-private/news/$id'
      path: '/news/$id'
      fullPath: '/news/$id'
      preLoaderRoute: typeof LayoutPrivateNewsIdImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/news/mutate': {
      id: '/_layout-private/news/mutate'
      path: '/news/mutate'
      fullPath: '/news/mutate'
      preLoaderRoute: typeof LayoutPrivateNewsMutateImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/dashboard/': {
      id: '/_layout-private/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof LayoutPrivateDashboardIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/finance/': {
      id: '/_layout-private/finance/'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof LayoutPrivateFinanceIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/law/': {
      id: '/_layout-private/law/'
      path: '/law'
      fullPath: '/law'
      preLoaderRoute: typeof LayoutPrivateLawIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/news/': {
      id: '/_layout-private/news/'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof LayoutPrivateNewsIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/operation/': {
      id: '/_layout-private/operation/'
      path: '/operation'
      fullPath: '/operation'
      preLoaderRoute: typeof LayoutPrivateOperationIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/account-management/soe': {
      id: '/_layout-private/account-management/soe'
      path: '/account-management/soe'
      fullPath: '/account-management/soe'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/account-management/soe/_information': {
      id: '/_layout-private/account-management/soe/_information'
      path: '/account-management/soe'
      fullPath: '/account-management/soe'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeRoute
    }
    '/_layout-private/report/action-plan/$id': {
      id: '/_layout-private/report/action-plan/$id'
      path: '/report/action-plan/$id'
      fullPath: '/report/action-plan/$id'
      preLoaderRoute: typeof LayoutPrivateReportActionPlanIdImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/action-plan/addnew': {
      id: '/_layout-private/report/action-plan/addnew'
      path: '/report/action-plan/addnew'
      fullPath: '/report/action-plan/addnew'
      preLoaderRoute: typeof LayoutPrivateReportActionPlanAddnewImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/action-plan/edit': {
      id: '/_layout-private/report/action-plan/edit'
      path: '/report/action-plan/edit'
      fullPath: '/report/action-plan/edit'
      preLoaderRoute: typeof LayoutPrivateReportActionPlanEditImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/action-plan/preview': {
      id: '/_layout-private/report/action-plan/preview'
      path: '/report/action-plan/preview'
      fullPath: '/report/action-plan/preview'
      preLoaderRoute: typeof LayoutPrivateReportActionPlanPreviewImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/account-management/soe/': {
      id: '/_layout-private/account-management/soe/'
      path: '/'
      fullPath: '/account-management/soe/'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeImport
    }
    '/_layout-private/account-management/sub-account/': {
      id: '/_layout-private/account-management/sub-account/'
      path: '/account-management/sub-account'
      fullPath: '/account-management/sub-account'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSubAccountIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/chat/_layout/': {
      id: '/_layout-private/chat/_layout/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof LayoutPrivateChatLayoutIndexImport
      parentRoute: typeof LayoutPrivateChatLayoutImport
    }
    '/_layout-private/report/action-plan/': {
      id: '/_layout-private/report/action-plan/'
      path: '/report/action-plan'
      fullPath: '/report/action-plan'
      preLoaderRoute: typeof LayoutPrivateReportActionPlanIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/board-of-directors/': {
      id: '/_layout-private/report/board-of-directors/'
      path: '/report/board-of-directors'
      fullPath: '/report/board-of-directors'
      preLoaderRoute: typeof LayoutPrivateReportBoardOfDirectorsIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/director/': {
      id: '/_layout-private/report/director/'
      path: '/report/director'
      fullPath: '/report/director'
      preLoaderRoute: typeof LayoutPrivateReportDirectorIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/finance/': {
      id: '/_layout-private/report/finance/'
      path: '/report/finance'
      fullPath: '/report/finance'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/non-financial-assessment/': {
      id: '/_layout-private/report/non-financial-assessment/'
      path: '/report/non-financial-assessment'
      fullPath: '/report/non-financial-assessment'
      preLoaderRoute: typeof LayoutPrivateReportNonFinancialAssessmentIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/obligation/': {
      id: '/_layout-private/report/obligation/'
      path: '/report/obligation'
      fullPath: '/report/obligation'
      preLoaderRoute: typeof LayoutPrivateReportObligationIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/overview/': {
      id: '/_layout-private/report/overview/'
      path: '/report/overview'
      fullPath: '/report/overview'
      preLoaderRoute: typeof LayoutPrivateReportOverviewIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/tax-obligations/': {
      id: '/_layout-private/report/tax-obligations/'
      path: '/report/tax-obligations'
      fullPath: '/report/tax-obligations'
      preLoaderRoute: typeof LayoutPrivateReportTaxObligationsIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/chat/_layout/group/mutate': {
      id: '/_layout-private/chat/_layout/group/mutate'
      path: '/group/mutate'
      fullPath: '/chat/group/mutate'
      preLoaderRoute: typeof LayoutPrivateChatLayoutGroupMutateImport
      parentRoute: typeof LayoutPrivateChatLayoutImport
    }
    '/_layout-private/chat/_layout/private/create': {
      id: '/_layout-private/chat/_layout/private/create'
      path: '/private/create'
      fullPath: '/chat/private/create'
      preLoaderRoute: typeof LayoutPrivateChatLayoutPrivateCreateImport
      parentRoute: typeof LayoutPrivateChatLayoutImport
    }
    '/_layout-private/report/finance/$id': {
      id: '/_layout-private/report/finance/$id'
      path: '/report/finance/$id'
      fullPath: '/report/finance/$id'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIdImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/finance/$id/_layout': {
      id: '/_layout-private/report/finance/$id/_layout'
      path: '/report/finance/$id'
      fullPath: '/report/finance/$id'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIdLayoutImport
      parentRoute: typeof LayoutPrivateReportFinanceIdRoute
    }
    '/_layout-private/report/finance/bank': {
      id: '/_layout-private/report/finance/bank'
      path: '/report/finance/bank'
      fullPath: '/report/finance/bank'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/finance/bank/_layout': {
      id: '/_layout-private/report/finance/bank/_layout'
      path: '/report/finance/bank'
      fullPath: '/report/finance/bank'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
      parentRoute: typeof LayoutPrivateReportFinanceBankRoute
    }
    '/_layout-private/report/finance/company': {
      id: '/_layout-private/report/finance/company'
      path: '/report/finance/company'
      fullPath: '/report/finance/company'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/finance/company/_layout': {
      id: '/_layout-private/report/finance/company/_layout'
      path: '/report/finance/company'
      fullPath: '/report/finance/company'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyRoute
    }
    '/_layout-private/report/obligation/assign-tax-obligation/$id': {
      id: '/_layout-private/report/obligation/assign-tax-obligation/$id'
      path: '/report/obligation/assign-tax-obligation/$id'
      fullPath: '/report/obligation/assign-tax-obligation/$id'
      preLoaderRoute: typeof LayoutPrivateReportObligationAssignTaxObligationIdImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/obligation/assign-tax-obligation/add-new': {
      id: '/_layout-private/report/obligation/assign-tax-obligation/add-new'
      path: '/report/obligation/assign-tax-obligation/add-new'
      fullPath: '/report/obligation/assign-tax-obligation/add-new'
      preLoaderRoute: typeof LayoutPrivateReportObligationAssignTaxObligationAddNewImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/obligation/assign-tax-obligation/edit': {
      id: '/_layout-private/report/obligation/assign-tax-obligation/edit'
      path: '/report/obligation/assign-tax-obligation/edit'
      fullPath: '/report/obligation/assign-tax-obligation/edit'
      preLoaderRoute: typeof LayoutPrivateReportObligationAssignTaxObligationEditImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/tax-obligations/dividend-plan/add-new': {
      id: '/_layout-private/report/tax-obligations/dividend-plan/add-new'
      path: '/report/tax-obligations/dividend-plan/add-new'
      fullPath: '/report/tax-obligations/dividend-plan/add-new'
      preLoaderRoute: typeof LayoutPrivateReportTaxObligationsDividendPlanAddNewImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/tax-obligations/dividend-plan/edit': {
      id: '/_layout-private/report/tax-obligations/dividend-plan/edit'
      path: '/report/tax-obligations/dividend-plan/edit'
      fullPath: '/report/tax-obligations/dividend-plan/edit'
      preLoaderRoute: typeof LayoutPrivateReportTaxObligationsDividendPlanEditImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/tax-obligations/tax-liability-plan/add-new': {
      id: '/_layout-private/report/tax-obligations/tax-liability-plan/add-new'
      path: '/report/tax-obligations/tax-liability-plan/add-new'
      fullPath: '/report/tax-obligations/tax-liability-plan/add-new'
      preLoaderRoute: typeof LayoutPrivateReportTaxObligationsTaxLiabilityPlanAddNewImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/tax-obligations/tax-liability-plan/edit': {
      id: '/_layout-private/report/tax-obligations/tax-liability-plan/edit'
      path: '/report/tax-obligations/tax-liability-plan/edit'
      fullPath: '/report/tax-obligations/tax-liability-plan/edit'
      preLoaderRoute: typeof LayoutPrivateReportTaxObligationsTaxLiabilityPlanEditImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/chat/_layout/$id/': {
      id: '/_layout-private/chat/_layout/$id/'
      path: '/$id'
      fullPath: '/chat/$id'
      preLoaderRoute: typeof LayoutPrivateChatLayoutIdIndexImport
      parentRoute: typeof LayoutPrivateChatLayoutImport
    }
    '/_layout-private/report/board-of-directors/details/': {
      id: '/_layout-private/report/board-of-directors/details/'
      path: '/report/board-of-directors/details'
      fullPath: '/report/board-of-directors/details'
      preLoaderRoute: typeof LayoutPrivateReportBoardOfDirectorsDetailsIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/director/details/': {
      id: '/_layout-private/report/director/details/'
      path: '/report/director/details'
      fullPath: '/report/director/details'
      preLoaderRoute: typeof LayoutPrivateReportDirectorDetailsIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/non-financial-assessment/answer/': {
      id: '/_layout-private/report/non-financial-assessment/answer/'
      path: '/report/non-financial-assessment/answer'
      fullPath: '/report/non-financial-assessment/answer'
      preLoaderRoute: typeof LayoutPrivateReportNonFinancialAssessmentAnswerIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/obligation/assign-tax-obligation/': {
      id: '/_layout-private/report/obligation/assign-tax-obligation/'
      path: '/report/obligation/assign-tax-obligation'
      fullPath: '/report/obligation/assign-tax-obligation'
      preLoaderRoute: typeof LayoutPrivateReportObligationAssignTaxObligationIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/obligation/dividend/': {
      id: '/_layout-private/report/obligation/dividend/'
      path: '/report/obligation/dividend'
      fullPath: '/report/obligation/dividend'
      preLoaderRoute: typeof LayoutPrivateReportObligationDividendIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/tax-obligations/dividend-plan/': {
      id: '/_layout-private/report/tax-obligations/dividend-plan/'
      path: '/report/tax-obligations/dividend-plan'
      fullPath: '/report/tax-obligations/dividend-plan'
      preLoaderRoute: typeof LayoutPrivateReportTaxObligationsDividendPlanIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/tax-obligations/tax-liability-plan/': {
      id: '/_layout-private/report/tax-obligations/tax-liability-plan/'
      path: '/report/tax-obligations/tax-liability-plan'
      fullPath: '/report/tax-obligations/tax-liability-plan'
      preLoaderRoute: typeof LayoutPrivateReportTaxObligationsTaxLiabilityPlanIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/account-management/soe/_information/board-of-directors/$id': {
      id: '/_layout-private/account-management/soe/_information/board-of-directors/$id'
      path: '/board-of-directors/$id'
      fullPath: '/account-management/soe/board-of-directors/$id'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIdImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/board-of-directors/mutate': {
      id: '/_layout-private/account-management/soe/_information/board-of-directors/mutate'
      path: '/board-of-directors/mutate'
      fullPath: '/account-management/soe/board-of-directors/mutate'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsMutateImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/board-of-directors/preview': {
      id: '/_layout-private/account-management/soe/_information/board-of-directors/preview'
      path: '/board-of-directors/preview'
      fullPath: '/account-management/soe/board-of-directors/preview'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsPreviewImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/department/$id': {
      id: '/_layout-private/account-management/soe/_information/department/$id'
      path: '/department/$id'
      fullPath: '/account-management/soe/department/$id'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDepartmentIdImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/department/mutate': {
      id: '/_layout-private/account-management/soe/_information/department/mutate'
      path: '/department/mutate'
      fullPath: '/account-management/soe/department/mutate'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDepartmentMutateImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/director/$id': {
      id: '/_layout-private/account-management/soe/_information/director/$id'
      path: '/director/$id'
      fullPath: '/account-management/soe/director/$id'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDirectorIdImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/director/mutate': {
      id: '/_layout-private/account-management/soe/_information/director/mutate'
      path: '/director/mutate'
      fullPath: '/account-management/soe/director/mutate'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDirectorMutateImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/director/preview': {
      id: '/_layout-private/account-management/soe/_information/director/preview'
      path: '/director/preview'
      fullPath: '/account-management/soe/director/preview'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDirectorPreviewImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/general/$id': {
      id: '/_layout-private/account-management/soe/_information/general/$id'
      path: '/general/$id'
      fullPath: '/account-management/soe/general/$id'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationGeneralIdImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/joint-venture/$id': {
      id: '/_layout-private/account-management/soe/_information/joint-venture/$id'
      path: '/joint-venture/$id'
      fullPath: '/account-management/soe/joint-venture/$id'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationJointVentureIdImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/joint-venture/mutate': {
      id: '/_layout-private/account-management/soe/_information/joint-venture/mutate'
      path: '/joint-venture/mutate'
      fullPath: '/account-management/soe/joint-venture/mutate'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationJointVentureMutateImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/land/$detailId': {
      id: '/_layout-private/account-management/soe/_information/land/$detailId'
      path: '/land/$detailId'
      fullPath: '/account-management/soe/land/$detailId'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationLandDetailIdImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/land/mutate': {
      id: '/_layout-private/account-management/soe/_information/land/mutate'
      path: '/land/mutate'
      fullPath: '/account-management/soe/land/mutate'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationLandMutateImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/chat/_layout/group/$id/document': {
      id: '/_layout-private/chat/_layout/group/$id/document'
      path: '/group/$id/document'
      fullPath: '/chat/group/$id/document'
      preLoaderRoute: typeof LayoutPrivateChatLayoutGroupIdDocumentImport
      parentRoute: typeof LayoutPrivateChatLayoutImport
    }
    '/_layout-private/chat/_layout/group/$id/info': {
      id: '/_layout-private/chat/_layout/group/$id/info'
      path: '/group/$id/info'
      fullPath: '/chat/group/$id/info'
      preLoaderRoute: typeof LayoutPrivateChatLayoutGroupIdInfoImport
      parentRoute: typeof LayoutPrivateChatLayoutImport
    }
    '/_layout-private/account-management/soe/_information/account/': {
      id: '/_layout-private/account-management/soe/_information/account/'
      path: '/account'
      fullPath: '/account-management/soe/account'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationAccountIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/board-of-directors/': {
      id: '/_layout-private/account-management/soe/_information/board-of-directors/'
      path: '/board-of-directors'
      fullPath: '/account-management/soe/board-of-directors'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/department/': {
      id: '/_layout-private/account-management/soe/_information/department/'
      path: '/department'
      fullPath: '/account-management/soe/department'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDepartmentIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/director/': {
      id: '/_layout-private/account-management/soe/_information/director/'
      path: '/director'
      fullPath: '/account-management/soe/director'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDirectorIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/general/': {
      id: '/_layout-private/account-management/soe/_information/general/'
      path: '/general'
      fullPath: '/account-management/soe/general'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationGeneralIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/joint-venture/': {
      id: '/_layout-private/account-management/soe/_information/joint-venture/'
      path: '/joint-venture'
      fullPath: '/account-management/soe/joint-venture'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationJointVentureIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/land/': {
      id: '/_layout-private/account-management/soe/_information/land/'
      path: '/land'
      fullPath: '/account-management/soe/land'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationLandIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/secretariat/': {
      id: '/_layout-private/account-management/soe/_information/secretariat/'
      path: '/secretariat'
      fullPath: '/account-management/soe/secretariat'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationSecretariatIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/chat/_layout/$id/document/': {
      id: '/_layout-private/chat/_layout/$id/document/'
      path: '/$id/document'
      fullPath: '/chat/$id/document'
      preLoaderRoute: typeof LayoutPrivateChatLayoutIdDocumentIndexImport
      parentRoute: typeof LayoutPrivateChatLayoutImport
    }
    '/_layout-private/chat/_layout/group/$id/': {
      id: '/_layout-private/chat/_layout/group/$id/'
      path: '/group/$id'
      fullPath: '/chat/group/$id'
      preLoaderRoute: typeof LayoutPrivateChatLayoutGroupIdIndexImport
      parentRoute: typeof LayoutPrivateChatLayoutImport
    }
    '/_layout-private/report/board-of-directors/details/answer/': {
      id: '/_layout-private/report/board-of-directors/details/answer/'
      path: '/report/board-of-directors/details/answer'
      fullPath: '/report/board-of-directors/details/answer'
      preLoaderRoute: typeof LayoutPrivateReportBoardOfDirectorsDetailsAnswerIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/director/details/answer/': {
      id: '/_layout-private/report/director/details/answer/'
      path: '/report/director/details/answer'
      fullPath: '/report/director/details/answer'
      preLoaderRoute: typeof LayoutPrivateReportDirectorDetailsAnswerIndexImport
      parentRoute: typeof LayoutPrivateImport
    }
    '/_layout-private/report/finance/bank/_layout/cash-flow/edit': {
      id: '/_layout-private/report/finance/bank/_layout/cash-flow/edit'
      path: '/cash-flow/edit'
      fullPath: '/report/finance/bank/cash-flow/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutCashFlowEditImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/finance-debt/edit': {
      id: '/_layout-private/report/finance/bank/_layout/finance-debt/edit'
      path: '/finance-debt/edit'
      fullPath: '/report/finance/bank/finance-debt/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutFinanceDebtEditImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/finance-property/edit': {
      id: '/_layout-private/report/finance/bank/_layout/finance-property/edit'
      path: '/finance-property/edit'
      fullPath: '/report/finance/bank/finance-property/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutFinancePropertyEditImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/owner-equity/edit': {
      id: '/_layout-private/report/finance/bank/_layout/owner-equity/edit'
      path: '/owner-equity/edit'
      fullPath: '/report/finance/bank/owner-equity/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutOwnerEquityEditImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/result/edit': {
      id: '/_layout-private/report/finance/bank/_layout/result/edit'
      path: '/result/edit'
      fullPath: '/report/finance/bank/result/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutResultEditImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/cash-flow-direct-method/edit': {
      id: '/_layout-private/report/finance/company/_layout/cash-flow-direct-method/edit'
      path: '/cash-flow-direct-method/edit'
      fullPath: '/report/finance/company/cash-flow-direct-method/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodEditImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/edit': {
      id: '/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/edit'
      path: '/cash-flow-indirect-method/edit'
      fullPath: '/report/finance/company/cash-flow-indirect-method/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodEditImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/finance-debt/edit': {
      id: '/_layout-private/report/finance/company/_layout/finance-debt/edit'
      path: '/finance-debt/edit'
      fullPath: '/report/finance/company/finance-debt/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFinanceDebtEditImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/finance-property/edit': {
      id: '/_layout-private/report/finance/company/_layout/finance-property/edit'
      path: '/finance-property/edit'
      fullPath: '/report/finance/company/finance-property/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFinancePropertyEditImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/fix-assets/add': {
      id: '/_layout-private/report/finance/company/_layout/fix-assets/add'
      path: '/fix-assets/add'
      fullPath: '/report/finance/company/fix-assets/add'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFixAssetsAddImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/fix-assets/edit': {
      id: '/_layout-private/report/finance/company/_layout/fix-assets/edit'
      path: '/fix-assets/edit'
      fullPath: '/report/finance/company/fix-assets/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFixAssetsEditImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/indicators/add': {
      id: '/_layout-private/report/finance/company/_layout/indicators/add'
      path: '/indicators/add'
      fullPath: '/report/finance/company/indicators/add'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutIndicatorsAddImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/indicators/edit': {
      id: '/_layout-private/report/finance/company/_layout/indicators/edit'
      path: '/indicators/edit'
      fullPath: '/report/finance/company/indicators/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutIndicatorsEditImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/owner-equity/edit': {
      id: '/_layout-private/report/finance/company/_layout/owner-equity/edit'
      path: '/owner-equity/edit'
      fullPath: '/report/finance/company/owner-equity/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutOwnerEquityEditImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/result/edit': {
      id: '/_layout-private/report/finance/company/_layout/result/edit'
      path: '/result/edit'
      fullPath: '/report/finance/company/result/edit'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutResultEditImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/account-management/soe/_information/department/add/': {
      id: '/_layout-private/account-management/soe/_information/department/add/'
      path: '/department/add'
      fullPath: '/account-management/soe/department/add'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDepartmentAddIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/director/add-new/': {
      id: '/_layout-private/account-management/soe/_information/director/add-new/'
      path: '/director/add-new'
      fullPath: '/account-management/soe/director/add-new'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationDirectorAddNewIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/general/edit/': {
      id: '/_layout-private/account-management/soe/_information/general/edit/'
      path: '/general/edit'
      fullPath: '/account-management/soe/general/edit'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationGeneralEditIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/joint-venture/add-new/': {
      id: '/_layout-private/account-management/soe/_information/joint-venture/add-new/'
      path: '/joint-venture/add-new'
      fullPath: '/account-management/soe/joint-venture/add-new'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationJointVentureAddNewIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/account-management/soe/_information/land/add/': {
      id: '/_layout-private/account-management/soe/_information/land/add/'
      path: '/land/add'
      fullPath: '/account-management/soe/land/add'
      preLoaderRoute: typeof LayoutPrivateAccountManagementSoeInformationLandAddIndexImport
      parentRoute: typeof LayoutPrivateAccountManagementSoeInformationImport
    }
    '/_layout-private/report/finance/$id/_layout/cash-flow-direct-method/': {
      id: '/_layout-private/report/finance/$id/_layout/cash-flow-direct-method/'
      path: '/cash-flow-direct-method'
      fullPath: '/report/finance/$id/cash-flow-direct-method'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIdLayoutCashFlowDirectMethodIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceIdLayoutImport
    }
    '/_layout-private/report/finance/$id/_layout/cash-flow-indirect-method/': {
      id: '/_layout-private/report/finance/$id/_layout/cash-flow-indirect-method/'
      path: '/cash-flow-indirect-method'
      fullPath: '/report/finance/$id/cash-flow-indirect-method'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIdLayoutCashFlowIndirectMethodIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceIdLayoutImport
    }
    '/_layout-private/report/finance/$id/_layout/finance-debt/': {
      id: '/_layout-private/report/finance/$id/_layout/finance-debt/'
      path: '/finance-debt'
      fullPath: '/report/finance/$id/finance-debt'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIdLayoutFinanceDebtIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceIdLayoutImport
    }
    '/_layout-private/report/finance/$id/_layout/finance-property/': {
      id: '/_layout-private/report/finance/$id/_layout/finance-property/'
      path: '/finance-property'
      fullPath: '/report/finance/$id/finance-property'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIdLayoutFinancePropertyIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceIdLayoutImport
    }
    '/_layout-private/report/finance/$id/_layout/owner-equity/': {
      id: '/_layout-private/report/finance/$id/_layout/owner-equity/'
      path: '/owner-equity'
      fullPath: '/report/finance/$id/owner-equity'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIdLayoutOwnerEquityIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceIdLayoutImport
    }
    '/_layout-private/report/finance/$id/_layout/result/': {
      id: '/_layout-private/report/finance/$id/_layout/result/'
      path: '/result'
      fullPath: '/report/finance/$id/result'
      preLoaderRoute: typeof LayoutPrivateReportFinanceIdLayoutResultIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceIdLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/cash-flow/': {
      id: '/_layout-private/report/finance/bank/_layout/cash-flow/'
      path: '/cash-flow'
      fullPath: '/report/finance/bank/cash-flow'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutCashFlowIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/finance-debt/': {
      id: '/_layout-private/report/finance/bank/_layout/finance-debt/'
      path: '/finance-debt'
      fullPath: '/report/finance/bank/finance-debt'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutFinanceDebtIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/finance-property/': {
      id: '/_layout-private/report/finance/bank/_layout/finance-property/'
      path: '/finance-property'
      fullPath: '/report/finance/bank/finance-property'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutFinancePropertyIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/owner-equity/': {
      id: '/_layout-private/report/finance/bank/_layout/owner-equity/'
      path: '/owner-equity'
      fullPath: '/report/finance/bank/owner-equity'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutOwnerEquityIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/bank/_layout/result/': {
      id: '/_layout-private/report/finance/bank/_layout/result/'
      path: '/result'
      fullPath: '/report/finance/bank/result'
      preLoaderRoute: typeof LayoutPrivateReportFinanceBankLayoutResultIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceBankLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/cash-flow-direct-method/': {
      id: '/_layout-private/report/finance/company/_layout/cash-flow-direct-method/'
      path: '/cash-flow-direct-method'
      fullPath: '/report/finance/company/cash-flow-direct-method'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/': {
      id: '/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/'
      path: '/cash-flow-indirect-method'
      fullPath: '/report/finance/company/cash-flow-indirect-method'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/finance-debt/': {
      id: '/_layout-private/report/finance/company/_layout/finance-debt/'
      path: '/finance-debt'
      fullPath: '/report/finance/company/finance-debt'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFinanceDebtIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/finance-property/': {
      id: '/_layout-private/report/finance/company/_layout/finance-property/'
      path: '/finance-property'
      fullPath: '/report/finance/company/finance-property'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFinancePropertyIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/fix-assets/': {
      id: '/_layout-private/report/finance/company/_layout/fix-assets/'
      path: '/fix-assets'
      fullPath: '/report/finance/company/fix-assets'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFixAssetsIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/indicators/': {
      id: '/_layout-private/report/finance/company/_layout/indicators/'
      path: '/indicators'
      fullPath: '/report/finance/company/indicators'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutIndicatorsIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/owner-equity/': {
      id: '/_layout-private/report/finance/company/_layout/owner-equity/'
      path: '/owner-equity'
      fullPath: '/report/finance/company/owner-equity'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutOwnerEquityIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/result/': {
      id: '/_layout-private/report/finance/company/_layout/result/'
      path: '/result'
      fullPath: '/report/finance/company/result'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutResultIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/cash-flow-direct-method/add/': {
      id: '/_layout-private/report/finance/company/_layout/cash-flow-direct-method/add/'
      path: '/cash-flow-direct-method/add'
      fullPath: '/report/finance/company/cash-flow-direct-method/add'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodAddIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/add/': {
      id: '/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/add/'
      path: '/cash-flow-indirect-method/add'
      fullPath: '/report/finance/company/cash-flow-indirect-method/add'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodAddIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/finance-debt/add/': {
      id: '/_layout-private/report/finance/company/_layout/finance-debt/add/'
      path: '/finance-debt/add'
      fullPath: '/report/finance/company/finance-debt/add'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFinanceDebtAddIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/finance-property/add/': {
      id: '/_layout-private/report/finance/company/_layout/finance-property/add/'
      path: '/finance-property/add'
      fullPath: '/report/finance/company/finance-property/add'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutFinancePropertyAddIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/owner-equity/add/': {
      id: '/_layout-private/report/finance/company/_layout/owner-equity/add/'
      path: '/owner-equity/add'
      fullPath: '/report/finance/company/owner-equity/add'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutOwnerEquityAddIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
    '/_layout-private/report/finance/company/_layout/result/add/': {
      id: '/_layout-private/report/finance/company/_layout/result/add/'
      path: '/result/add'
      fullPath: '/report/finance/company/result/add'
      preLoaderRoute: typeof LayoutPrivateReportFinanceCompanyLayoutResultAddIndexImport
      parentRoute: typeof LayoutPrivateReportFinanceCompanyLayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  LayoutPrivateRoute: LayoutPrivateRoute.addChildren({
    LayoutPrivateChatRoute: LayoutPrivateChatRoute.addChildren({
      LayoutPrivateChatLayoutRoute: LayoutPrivateChatLayoutRoute.addChildren({
        LayoutPrivateChatLayoutIndexRoute,
        LayoutPrivateChatLayoutGroupMutateRoute,
        LayoutPrivateChatLayoutPrivateCreateRoute,
        LayoutPrivateChatLayoutIdIndexRoute,
        LayoutPrivateChatLayoutGroupIdDocumentRoute,
        LayoutPrivateChatLayoutGroupIdInfoRoute,
        LayoutPrivateChatLayoutIdDocumentIndexRoute,
        LayoutPrivateChatLayoutGroupIdIndexRoute,
      }),
    }),
    LayoutPrivateLawIdRoute,
    LayoutPrivateLawMutateRoute,
    LayoutPrivateNewsIdRoute,
    LayoutPrivateNewsMutateRoute,
    LayoutPrivateDashboardIndexRoute,
    LayoutPrivateFinanceIndexRoute,
    LayoutPrivateLawIndexRoute,
    LayoutPrivateNewsIndexRoute,
    LayoutPrivateOperationIndexRoute,
    LayoutPrivateAccountManagementSoeRoute:
      LayoutPrivateAccountManagementSoeRoute.addChildren({
        LayoutPrivateAccountManagementSoeInformationRoute:
          LayoutPrivateAccountManagementSoeInformationRoute.addChildren({
            LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIdRoute,
            LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsMutateRoute,
            LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsPreviewRoute,
            LayoutPrivateAccountManagementSoeInformationDepartmentIdRoute,
            LayoutPrivateAccountManagementSoeInformationDepartmentMutateRoute,
            LayoutPrivateAccountManagementSoeInformationDirectorIdRoute,
            LayoutPrivateAccountManagementSoeInformationDirectorMutateRoute,
            LayoutPrivateAccountManagementSoeInformationDirectorPreviewRoute,
            LayoutPrivateAccountManagementSoeInformationGeneralIdRoute,
            LayoutPrivateAccountManagementSoeInformationJointVentureIdRoute,
            LayoutPrivateAccountManagementSoeInformationJointVentureMutateRoute,
            LayoutPrivateAccountManagementSoeInformationLandDetailIdRoute,
            LayoutPrivateAccountManagementSoeInformationLandMutateRoute,
            LayoutPrivateAccountManagementSoeInformationAccountIndexRoute,
            LayoutPrivateAccountManagementSoeInformationBoardOfDirectorsIndexRoute,
            LayoutPrivateAccountManagementSoeInformationDepartmentIndexRoute,
            LayoutPrivateAccountManagementSoeInformationDirectorIndexRoute,
            LayoutPrivateAccountManagementSoeInformationGeneralIndexRoute,
            LayoutPrivateAccountManagementSoeInformationJointVentureIndexRoute,
            LayoutPrivateAccountManagementSoeInformationLandIndexRoute,
            LayoutPrivateAccountManagementSoeInformationSecretariatIndexRoute,
            LayoutPrivateAccountManagementSoeInformationDepartmentAddIndexRoute,
            LayoutPrivateAccountManagementSoeInformationDirectorAddNewIndexRoute,
            LayoutPrivateAccountManagementSoeInformationGeneralEditIndexRoute,
            LayoutPrivateAccountManagementSoeInformationJointVentureAddNewIndexRoute,
            LayoutPrivateAccountManagementSoeInformationLandAddIndexRoute,
          }),
        LayoutPrivateAccountManagementSoeIndexRoute,
      }),
    LayoutPrivateReportActionPlanIdRoute,
    LayoutPrivateReportActionPlanAddnewRoute,
    LayoutPrivateReportActionPlanEditRoute,
    LayoutPrivateReportActionPlanPreviewRoute,
    LayoutPrivateAccountManagementSubAccountIndexRoute,
    LayoutPrivateReportActionPlanIndexRoute,
    LayoutPrivateReportBoardOfDirectorsIndexRoute,
    LayoutPrivateReportDirectorIndexRoute,
    LayoutPrivateReportFinanceIndexRoute,
    LayoutPrivateReportNonFinancialAssessmentIndexRoute,
    LayoutPrivateReportObligationIndexRoute,
    LayoutPrivateReportOverviewIndexRoute,
    LayoutPrivateReportTaxObligationsIndexRoute,
    LayoutPrivateReportFinanceIdRoute:
      LayoutPrivateReportFinanceIdRoute.addChildren({
        LayoutPrivateReportFinanceIdLayoutRoute:
          LayoutPrivateReportFinanceIdLayoutRoute.addChildren({
            LayoutPrivateReportFinanceIdLayoutCashFlowDirectMethodIndexRoute,
            LayoutPrivateReportFinanceIdLayoutCashFlowIndirectMethodIndexRoute,
            LayoutPrivateReportFinanceIdLayoutFinanceDebtIndexRoute,
            LayoutPrivateReportFinanceIdLayoutFinancePropertyIndexRoute,
            LayoutPrivateReportFinanceIdLayoutOwnerEquityIndexRoute,
            LayoutPrivateReportFinanceIdLayoutResultIndexRoute,
          }),
      }),
    LayoutPrivateReportFinanceBankRoute:
      LayoutPrivateReportFinanceBankRoute.addChildren({
        LayoutPrivateReportFinanceBankLayoutRoute:
          LayoutPrivateReportFinanceBankLayoutRoute.addChildren({
            LayoutPrivateReportFinanceBankLayoutCashFlowEditRoute,
            LayoutPrivateReportFinanceBankLayoutFinanceDebtEditRoute,
            LayoutPrivateReportFinanceBankLayoutFinancePropertyEditRoute,
            LayoutPrivateReportFinanceBankLayoutOwnerEquityEditRoute,
            LayoutPrivateReportFinanceBankLayoutResultEditRoute,
            LayoutPrivateReportFinanceBankLayoutCashFlowIndexRoute,
            LayoutPrivateReportFinanceBankLayoutFinanceDebtIndexRoute,
            LayoutPrivateReportFinanceBankLayoutFinancePropertyIndexRoute,
            LayoutPrivateReportFinanceBankLayoutOwnerEquityIndexRoute,
            LayoutPrivateReportFinanceBankLayoutResultIndexRoute,
          }),
      }),
    LayoutPrivateReportFinanceCompanyRoute:
      LayoutPrivateReportFinanceCompanyRoute.addChildren({
        LayoutPrivateReportFinanceCompanyLayoutRoute:
          LayoutPrivateReportFinanceCompanyLayoutRoute.addChildren({
            LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodEditRoute,
            LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodEditRoute,
            LayoutPrivateReportFinanceCompanyLayoutFinanceDebtEditRoute,
            LayoutPrivateReportFinanceCompanyLayoutFinancePropertyEditRoute,
            LayoutPrivateReportFinanceCompanyLayoutFixAssetsAddRoute,
            LayoutPrivateReportFinanceCompanyLayoutFixAssetsEditRoute,
            LayoutPrivateReportFinanceCompanyLayoutIndicatorsAddRoute,
            LayoutPrivateReportFinanceCompanyLayoutIndicatorsEditRoute,
            LayoutPrivateReportFinanceCompanyLayoutOwnerEquityEditRoute,
            LayoutPrivateReportFinanceCompanyLayoutResultEditRoute,
            LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutFinanceDebtIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutFinancePropertyIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutFixAssetsIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutIndicatorsIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutOwnerEquityIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutResultIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutCashFlowDirectMethodAddIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutCashFlowIndirectMethodAddIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutFinanceDebtAddIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutFinancePropertyAddIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutOwnerEquityAddIndexRoute,
            LayoutPrivateReportFinanceCompanyLayoutResultAddIndexRoute,
          }),
      }),
    LayoutPrivateReportObligationAssignTaxObligationIdRoute,
    LayoutPrivateReportObligationAssignTaxObligationAddNewRoute,
    LayoutPrivateReportObligationAssignTaxObligationEditRoute,
    LayoutPrivateReportTaxObligationsDividendPlanAddNewRoute,
    LayoutPrivateReportTaxObligationsDividendPlanEditRoute,
    LayoutPrivateReportTaxObligationsTaxLiabilityPlanAddNewRoute,
    LayoutPrivateReportTaxObligationsTaxLiabilityPlanEditRoute,
    LayoutPrivateReportBoardOfDirectorsDetailsIndexRoute,
    LayoutPrivateReportDirectorDetailsIndexRoute,
    LayoutPrivateReportNonFinancialAssessmentAnswerIndexRoute,
    LayoutPrivateReportObligationAssignTaxObligationIndexRoute,
    LayoutPrivateReportObligationDividendIndexRoute,
    LayoutPrivateReportTaxObligationsDividendPlanIndexRoute,
    LayoutPrivateReportTaxObligationsTaxLiabilityPlanIndexRoute,
    LayoutPrivateReportBoardOfDirectorsDetailsAnswerIndexRoute,
    LayoutPrivateReportDirectorDetailsAnswerIndexRoute,
  }),
  DocumentViewerRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_layout-private",
        "/document-viewer"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_layout-private": {
      "filePath": "_layout-private.tsx",
      "children": [
        "/_layout-private/chat",
        "/_layout-private/law/$id",
        "/_layout-private/law/mutate",
        "/_layout-private/news/$id",
        "/_layout-private/news/mutate",
        "/_layout-private/dashboard/",
        "/_layout-private/finance/",
        "/_layout-private/law/",
        "/_layout-private/news/",
        "/_layout-private/operation/",
        "/_layout-private/account-management/soe",
        "/_layout-private/report/action-plan/$id",
        "/_layout-private/report/action-plan/addnew",
        "/_layout-private/report/action-plan/edit",
        "/_layout-private/report/action-plan/preview",
        "/_layout-private/account-management/sub-account/",
        "/_layout-private/report/action-plan/",
        "/_layout-private/report/board-of-directors/",
        "/_layout-private/report/director/",
        "/_layout-private/report/finance/",
        "/_layout-private/report/non-financial-assessment/",
        "/_layout-private/report/obligation/",
        "/_layout-private/report/overview/",
        "/_layout-private/report/tax-obligations/",
        "/_layout-private/report/finance/$id",
        "/_layout-private/report/finance/bank",
        "/_layout-private/report/finance/company",
        "/_layout-private/report/obligation/assign-tax-obligation/$id",
        "/_layout-private/report/obligation/assign-tax-obligation/add-new",
        "/_layout-private/report/obligation/assign-tax-obligation/edit",
        "/_layout-private/report/tax-obligations/dividend-plan/add-new",
        "/_layout-private/report/tax-obligations/dividend-plan/edit",
        "/_layout-private/report/tax-obligations/tax-liability-plan/add-new",
        "/_layout-private/report/tax-obligations/tax-liability-plan/edit",
        "/_layout-private/report/board-of-directors/details/",
        "/_layout-private/report/director/details/",
        "/_layout-private/report/non-financial-assessment/answer/",
        "/_layout-private/report/obligation/assign-tax-obligation/",
        "/_layout-private/report/obligation/dividend/",
        "/_layout-private/report/tax-obligations/dividend-plan/",
        "/_layout-private/report/tax-obligations/tax-liability-plan/",
        "/_layout-private/report/board-of-directors/details/answer/",
        "/_layout-private/report/director/details/answer/"
      ]
    },
    "/document-viewer": {
      "filePath": "document-viewer.tsx"
    },
    "/_layout-private/chat": {
      "filePath": "_layout-private/chat",
      "parent": "/_layout-private",
      "children": [
        "/_layout-private/chat/_layout"
      ]
    },
    "/_layout-private/chat/_layout": {
      "filePath": "_layout-private/chat/_layout.tsx",
      "parent": "/_layout-private/chat",
      "children": [
        "/_layout-private/chat/_layout/",
        "/_layout-private/chat/_layout/group/mutate",
        "/_layout-private/chat/_layout/private/create",
        "/_layout-private/chat/_layout/$id/",
        "/_layout-private/chat/_layout/group/$id/document",
        "/_layout-private/chat/_layout/group/$id/info",
        "/_layout-private/chat/_layout/$id/document/",
        "/_layout-private/chat/_layout/group/$id/"
      ]
    },
    "/_layout-private/law/$id": {
      "filePath": "_layout-private/law/$id.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/law/mutate": {
      "filePath": "_layout-private/law/mutate.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/news/$id": {
      "filePath": "_layout-private/news/$id.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/news/mutate": {
      "filePath": "_layout-private/news/mutate.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/dashboard/": {
      "filePath": "_layout-private/dashboard/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/finance/": {
      "filePath": "_layout-private/finance/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/law/": {
      "filePath": "_layout-private/law/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/news/": {
      "filePath": "_layout-private/news/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/operation/": {
      "filePath": "_layout-private/operation/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/account-management/soe": {
      "filePath": "_layout-private/account-management/soe",
      "parent": "/_layout-private",
      "children": [
        "/_layout-private/account-management/soe/_information",
        "/_layout-private/account-management/soe/"
      ]
    },
    "/_layout-private/account-management/soe/_information": {
      "filePath": "_layout-private/account-management/soe/_information.tsx",
      "parent": "/_layout-private/account-management/soe",
      "children": [
        "/_layout-private/account-management/soe/_information/board-of-directors/$id",
        "/_layout-private/account-management/soe/_information/board-of-directors/mutate",
        "/_layout-private/account-management/soe/_information/board-of-directors/preview",
        "/_layout-private/account-management/soe/_information/department/$id",
        "/_layout-private/account-management/soe/_information/department/mutate",
        "/_layout-private/account-management/soe/_information/director/$id",
        "/_layout-private/account-management/soe/_information/director/mutate",
        "/_layout-private/account-management/soe/_information/director/preview",
        "/_layout-private/account-management/soe/_information/general/$id",
        "/_layout-private/account-management/soe/_information/joint-venture/$id",
        "/_layout-private/account-management/soe/_information/joint-venture/mutate",
        "/_layout-private/account-management/soe/_information/land/$detailId",
        "/_layout-private/account-management/soe/_information/land/mutate",
        "/_layout-private/account-management/soe/_information/account/",
        "/_layout-private/account-management/soe/_information/board-of-directors/",
        "/_layout-private/account-management/soe/_information/department/",
        "/_layout-private/account-management/soe/_information/director/",
        "/_layout-private/account-management/soe/_information/general/",
        "/_layout-private/account-management/soe/_information/joint-venture/",
        "/_layout-private/account-management/soe/_information/land/",
        "/_layout-private/account-management/soe/_information/secretariat/",
        "/_layout-private/account-management/soe/_information/department/add/",
        "/_layout-private/account-management/soe/_information/director/add-new/",
        "/_layout-private/account-management/soe/_information/general/edit/",
        "/_layout-private/account-management/soe/_information/joint-venture/add-new/",
        "/_layout-private/account-management/soe/_information/land/add/"
      ]
    },
    "/_layout-private/report/action-plan/$id": {
      "filePath": "_layout-private/report/action-plan/$id.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/action-plan/addnew": {
      "filePath": "_layout-private/report/action-plan/addnew.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/action-plan/edit": {
      "filePath": "_layout-private/report/action-plan/edit.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/action-plan/preview": {
      "filePath": "_layout-private/report/action-plan/preview.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/account-management/soe/": {
      "filePath": "_layout-private/account-management/soe/index.tsx",
      "parent": "/_layout-private/account-management/soe"
    },
    "/_layout-private/account-management/sub-account/": {
      "filePath": "_layout-private/account-management/sub-account/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/chat/_layout/": {
      "filePath": "_layout-private/chat/_layout/index.tsx",
      "parent": "/_layout-private/chat/_layout"
    },
    "/_layout-private/report/action-plan/": {
      "filePath": "_layout-private/report/action-plan/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/board-of-directors/": {
      "filePath": "_layout-private/report/board-of-directors/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/director/": {
      "filePath": "_layout-private/report/director/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/finance/": {
      "filePath": "_layout-private/report/finance/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/non-financial-assessment/": {
      "filePath": "_layout-private/report/non-financial-assessment/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/obligation/": {
      "filePath": "_layout-private/report/obligation/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/overview/": {
      "filePath": "_layout-private/report/overview/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/tax-obligations/": {
      "filePath": "_layout-private/report/tax-obligations/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/chat/_layout/group/mutate": {
      "filePath": "_layout-private/chat/_layout/group/mutate.tsx",
      "parent": "/_layout-private/chat/_layout"
    },
    "/_layout-private/chat/_layout/private/create": {
      "filePath": "_layout-private/chat/_layout/private/create.tsx",
      "parent": "/_layout-private/chat/_layout"
    },
    "/_layout-private/report/finance/$id": {
      "filePath": "_layout-private/report/finance/$id",
      "parent": "/_layout-private",
      "children": [
        "/_layout-private/report/finance/$id/_layout"
      ]
    },
    "/_layout-private/report/finance/$id/_layout": {
      "filePath": "_layout-private/report/finance/$id/_layout.tsx",
      "parent": "/_layout-private/report/finance/$id",
      "children": [
        "/_layout-private/report/finance/$id/_layout/cash-flow-direct-method/",
        "/_layout-private/report/finance/$id/_layout/cash-flow-indirect-method/",
        "/_layout-private/report/finance/$id/_layout/finance-debt/",
        "/_layout-private/report/finance/$id/_layout/finance-property/",
        "/_layout-private/report/finance/$id/_layout/owner-equity/",
        "/_layout-private/report/finance/$id/_layout/result/"
      ]
    },
    "/_layout-private/report/finance/bank": {
      "filePath": "_layout-private/report/finance/bank",
      "parent": "/_layout-private",
      "children": [
        "/_layout-private/report/finance/bank/_layout"
      ]
    },
    "/_layout-private/report/finance/bank/_layout": {
      "filePath": "_layout-private/report/finance/bank/_layout.tsx",
      "parent": "/_layout-private/report/finance/bank",
      "children": [
        "/_layout-private/report/finance/bank/_layout/cash-flow/edit",
        "/_layout-private/report/finance/bank/_layout/finance-debt/edit",
        "/_layout-private/report/finance/bank/_layout/finance-property/edit",
        "/_layout-private/report/finance/bank/_layout/owner-equity/edit",
        "/_layout-private/report/finance/bank/_layout/result/edit",
        "/_layout-private/report/finance/bank/_layout/cash-flow/",
        "/_layout-private/report/finance/bank/_layout/finance-debt/",
        "/_layout-private/report/finance/bank/_layout/finance-property/",
        "/_layout-private/report/finance/bank/_layout/owner-equity/",
        "/_layout-private/report/finance/bank/_layout/result/"
      ]
    },
    "/_layout-private/report/finance/company": {
      "filePath": "_layout-private/report/finance/company",
      "parent": "/_layout-private",
      "children": [
        "/_layout-private/report/finance/company/_layout"
      ]
    },
    "/_layout-private/report/finance/company/_layout": {
      "filePath": "_layout-private/report/finance/company/_layout.tsx",
      "parent": "/_layout-private/report/finance/company",
      "children": [
        "/_layout-private/report/finance/company/_layout/cash-flow-direct-method/edit",
        "/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/edit",
        "/_layout-private/report/finance/company/_layout/finance-debt/edit",
        "/_layout-private/report/finance/company/_layout/finance-property/edit",
        "/_layout-private/report/finance/company/_layout/fix-assets/add",
        "/_layout-private/report/finance/company/_layout/fix-assets/edit",
        "/_layout-private/report/finance/company/_layout/indicators/add",
        "/_layout-private/report/finance/company/_layout/indicators/edit",
        "/_layout-private/report/finance/company/_layout/owner-equity/edit",
        "/_layout-private/report/finance/company/_layout/result/edit",
        "/_layout-private/report/finance/company/_layout/cash-flow-direct-method/",
        "/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/",
        "/_layout-private/report/finance/company/_layout/finance-debt/",
        "/_layout-private/report/finance/company/_layout/finance-property/",
        "/_layout-private/report/finance/company/_layout/fix-assets/",
        "/_layout-private/report/finance/company/_layout/indicators/",
        "/_layout-private/report/finance/company/_layout/owner-equity/",
        "/_layout-private/report/finance/company/_layout/result/",
        "/_layout-private/report/finance/company/_layout/cash-flow-direct-method/add/",
        "/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/add/",
        "/_layout-private/report/finance/company/_layout/finance-debt/add/",
        "/_layout-private/report/finance/company/_layout/finance-property/add/",
        "/_layout-private/report/finance/company/_layout/owner-equity/add/",
        "/_layout-private/report/finance/company/_layout/result/add/"
      ]
    },
    "/_layout-private/report/obligation/assign-tax-obligation/$id": {
      "filePath": "_layout-private/report/obligation/assign-tax-obligation/$id.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/obligation/assign-tax-obligation/add-new": {
      "filePath": "_layout-private/report/obligation/assign-tax-obligation/add-new.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/obligation/assign-tax-obligation/edit": {
      "filePath": "_layout-private/report/obligation/assign-tax-obligation/edit.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/tax-obligations/dividend-plan/add-new": {
      "filePath": "_layout-private/report/tax-obligations/dividend-plan/add-new.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/tax-obligations/dividend-plan/edit": {
      "filePath": "_layout-private/report/tax-obligations/dividend-plan/edit.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/tax-obligations/tax-liability-plan/add-new": {
      "filePath": "_layout-private/report/tax-obligations/tax-liability-plan/add-new.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/tax-obligations/tax-liability-plan/edit": {
      "filePath": "_layout-private/report/tax-obligations/tax-liability-plan/edit.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/chat/_layout/$id/": {
      "filePath": "_layout-private/chat/_layout/$id/index.tsx",
      "parent": "/_layout-private/chat/_layout"
    },
    "/_layout-private/report/board-of-directors/details/": {
      "filePath": "_layout-private/report/board-of-directors/details/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/director/details/": {
      "filePath": "_layout-private/report/director/details/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/non-financial-assessment/answer/": {
      "filePath": "_layout-private/report/non-financial-assessment/answer/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/obligation/assign-tax-obligation/": {
      "filePath": "_layout-private/report/obligation/assign-tax-obligation/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/obligation/dividend/": {
      "filePath": "_layout-private/report/obligation/dividend/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/tax-obligations/dividend-plan/": {
      "filePath": "_layout-private/report/tax-obligations/dividend-plan/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/tax-obligations/tax-liability-plan/": {
      "filePath": "_layout-private/report/tax-obligations/tax-liability-plan/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/account-management/soe/_information/board-of-directors/$id": {
      "filePath": "_layout-private/account-management/soe/_information/board-of-directors/$id.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/board-of-directors/mutate": {
      "filePath": "_layout-private/account-management/soe/_information/board-of-directors/mutate.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/board-of-directors/preview": {
      "filePath": "_layout-private/account-management/soe/_information/board-of-directors/preview.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/department/$id": {
      "filePath": "_layout-private/account-management/soe/_information/department/$id.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/department/mutate": {
      "filePath": "_layout-private/account-management/soe/_information/department/mutate.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/director/$id": {
      "filePath": "_layout-private/account-management/soe/_information/director/$id.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/director/mutate": {
      "filePath": "_layout-private/account-management/soe/_information/director/mutate.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/director/preview": {
      "filePath": "_layout-private/account-management/soe/_information/director/preview.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/general/$id": {
      "filePath": "_layout-private/account-management/soe/_information/general/$id.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/joint-venture/$id": {
      "filePath": "_layout-private/account-management/soe/_information/joint-venture/$id.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/joint-venture/mutate": {
      "filePath": "_layout-private/account-management/soe/_information/joint-venture/mutate.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/land/$detailId": {
      "filePath": "_layout-private/account-management/soe/_information/land/$detailId.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/land/mutate": {
      "filePath": "_layout-private/account-management/soe/_information/land/mutate.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/chat/_layout/group/$id/document": {
      "filePath": "_layout-private/chat/_layout/group/$id/document.tsx",
      "parent": "/_layout-private/chat/_layout"
    },
    "/_layout-private/chat/_layout/group/$id/info": {
      "filePath": "_layout-private/chat/_layout/group/$id/info.tsx",
      "parent": "/_layout-private/chat/_layout"
    },
    "/_layout-private/account-management/soe/_information/account/": {
      "filePath": "_layout-private/account-management/soe/_information/account/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/board-of-directors/": {
      "filePath": "_layout-private/account-management/soe/_information/board-of-directors/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/department/": {
      "filePath": "_layout-private/account-management/soe/_information/department/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/director/": {
      "filePath": "_layout-private/account-management/soe/_information/director/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/general/": {
      "filePath": "_layout-private/account-management/soe/_information/general/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/joint-venture/": {
      "filePath": "_layout-private/account-management/soe/_information/joint-venture/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/land/": {
      "filePath": "_layout-private/account-management/soe/_information/land/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/secretariat/": {
      "filePath": "_layout-private/account-management/soe/_information/secretariat/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/chat/_layout/$id/document/": {
      "filePath": "_layout-private/chat/_layout/$id/document/index.tsx",
      "parent": "/_layout-private/chat/_layout"
    },
    "/_layout-private/chat/_layout/group/$id/": {
      "filePath": "_layout-private/chat/_layout/group/$id/index.tsx",
      "parent": "/_layout-private/chat/_layout"
    },
    "/_layout-private/report/board-of-directors/details/answer/": {
      "filePath": "_layout-private/report/board-of-directors/details/answer/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/director/details/answer/": {
      "filePath": "_layout-private/report/director/details/answer/index.tsx",
      "parent": "/_layout-private"
    },
    "/_layout-private/report/finance/bank/_layout/cash-flow/edit": {
      "filePath": "_layout-private/report/finance/bank/_layout/cash-flow/edit.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/finance-debt/edit": {
      "filePath": "_layout-private/report/finance/bank/_layout/finance-debt/edit.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/finance-property/edit": {
      "filePath": "_layout-private/report/finance/bank/_layout/finance-property/edit.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/owner-equity/edit": {
      "filePath": "_layout-private/report/finance/bank/_layout/owner-equity/edit.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/result/edit": {
      "filePath": "_layout-private/report/finance/bank/_layout/result/edit.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/company/_layout/cash-flow-direct-method/edit": {
      "filePath": "_layout-private/report/finance/company/_layout/cash-flow-direct-method/edit.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/edit": {
      "filePath": "_layout-private/report/finance/company/_layout/cash-flow-indirect-method/edit.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/finance-debt/edit": {
      "filePath": "_layout-private/report/finance/company/_layout/finance-debt/edit.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/finance-property/edit": {
      "filePath": "_layout-private/report/finance/company/_layout/finance-property/edit.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/fix-assets/add": {
      "filePath": "_layout-private/report/finance/company/_layout/fix-assets/add.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/fix-assets/edit": {
      "filePath": "_layout-private/report/finance/company/_layout/fix-assets/edit.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/indicators/add": {
      "filePath": "_layout-private/report/finance/company/_layout/indicators/add.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/indicators/edit": {
      "filePath": "_layout-private/report/finance/company/_layout/indicators/edit.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/owner-equity/edit": {
      "filePath": "_layout-private/report/finance/company/_layout/owner-equity/edit.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/result/edit": {
      "filePath": "_layout-private/report/finance/company/_layout/result/edit.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/account-management/soe/_information/department/add/": {
      "filePath": "_layout-private/account-management/soe/_information/department/add/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/director/add-new/": {
      "filePath": "_layout-private/account-management/soe/_information/director/add-new/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/general/edit/": {
      "filePath": "_layout-private/account-management/soe/_information/general/edit/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/joint-venture/add-new/": {
      "filePath": "_layout-private/account-management/soe/_information/joint-venture/add-new/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/account-management/soe/_information/land/add/": {
      "filePath": "_layout-private/account-management/soe/_information/land/add/index.tsx",
      "parent": "/_layout-private/account-management/soe/_information"
    },
    "/_layout-private/report/finance/$id/_layout/cash-flow-direct-method/": {
      "filePath": "_layout-private/report/finance/$id/_layout/cash-flow-direct-method/index.tsx",
      "parent": "/_layout-private/report/finance/$id/_layout"
    },
    "/_layout-private/report/finance/$id/_layout/cash-flow-indirect-method/": {
      "filePath": "_layout-private/report/finance/$id/_layout/cash-flow-indirect-method/index.tsx",
      "parent": "/_layout-private/report/finance/$id/_layout"
    },
    "/_layout-private/report/finance/$id/_layout/finance-debt/": {
      "filePath": "_layout-private/report/finance/$id/_layout/finance-debt/index.tsx",
      "parent": "/_layout-private/report/finance/$id/_layout"
    },
    "/_layout-private/report/finance/$id/_layout/finance-property/": {
      "filePath": "_layout-private/report/finance/$id/_layout/finance-property/index.tsx",
      "parent": "/_layout-private/report/finance/$id/_layout"
    },
    "/_layout-private/report/finance/$id/_layout/owner-equity/": {
      "filePath": "_layout-private/report/finance/$id/_layout/owner-equity/index.tsx",
      "parent": "/_layout-private/report/finance/$id/_layout"
    },
    "/_layout-private/report/finance/$id/_layout/result/": {
      "filePath": "_layout-private/report/finance/$id/_layout/result/index.tsx",
      "parent": "/_layout-private/report/finance/$id/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/cash-flow/": {
      "filePath": "_layout-private/report/finance/bank/_layout/cash-flow/index.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/finance-debt/": {
      "filePath": "_layout-private/report/finance/bank/_layout/finance-debt/index.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/finance-property/": {
      "filePath": "_layout-private/report/finance/bank/_layout/finance-property/index.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/owner-equity/": {
      "filePath": "_layout-private/report/finance/bank/_layout/owner-equity/index.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/bank/_layout/result/": {
      "filePath": "_layout-private/report/finance/bank/_layout/result/index.tsx",
      "parent": "/_layout-private/report/finance/bank/_layout"
    },
    "/_layout-private/report/finance/company/_layout/cash-flow-direct-method/": {
      "filePath": "_layout-private/report/finance/company/_layout/cash-flow-direct-method/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/": {
      "filePath": "_layout-private/report/finance/company/_layout/cash-flow-indirect-method/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/finance-debt/": {
      "filePath": "_layout-private/report/finance/company/_layout/finance-debt/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/finance-property/": {
      "filePath": "_layout-private/report/finance/company/_layout/finance-property/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/fix-assets/": {
      "filePath": "_layout-private/report/finance/company/_layout/fix-assets/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/indicators/": {
      "filePath": "_layout-private/report/finance/company/_layout/indicators/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/owner-equity/": {
      "filePath": "_layout-private/report/finance/company/_layout/owner-equity/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/result/": {
      "filePath": "_layout-private/report/finance/company/_layout/result/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/cash-flow-direct-method/add/": {
      "filePath": "_layout-private/report/finance/company/_layout/cash-flow-direct-method/add/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/cash-flow-indirect-method/add/": {
      "filePath": "_layout-private/report/finance/company/_layout/cash-flow-indirect-method/add/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/finance-debt/add/": {
      "filePath": "_layout-private/report/finance/company/_layout/finance-debt/add/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/finance-property/add/": {
      "filePath": "_layout-private/report/finance/company/_layout/finance-property/add/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/owner-equity/add/": {
      "filePath": "_layout-private/report/finance/company/_layout/owner-equity/add/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    },
    "/_layout-private/report/finance/company/_layout/result/add/": {
      "filePath": "_layout-private/report/finance/company/_layout/result/add/index.tsx",
      "parent": "/_layout-private/report/finance/company/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
